import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    itemIcon: {
        marginRight: 10,
        pointerEvents: 'none',
        '& img': {
            height: 20,
            pointerEvents: 'none',
        }
    }
});